import { generateClient, GraphQLResult } from "aws-amplify/api";
// @ts-ignore
import { batchGetFormGroupsForPhotoLogs } from "../graphql/queries";
import { bulkGetPhotoLogs } from "../db/queries/formGroupQueries";
import { recordSentry } from "utils/recordSentry";
import { FormGroup } from "db/definitions";

/**
 * Given the photolog (formGroup) ids, retrieves the photologs from the relevant db
 * @param ids The photolog ids
 * @param online Whether or not the user is online
 * @returns The photologs (they are a type of formGroup remember)
 */
async function batchRetrievePhotoLogs(ids: string[], online: boolean): Promise<FormGroup[]> {
	if (ids.length > 0) {
		try {
			if (online) {
				interface QueryResponse {
					batchGetFormGroups: FormGroup[];
				}
				const client = generateClient({ authMode: "userPool" });
				const result = (await client.graphql({
					query: batchGetFormGroupsForPhotoLogs,
					variables: { ids },
					authMode: "userPool",
				})) as GraphQLResult<QueryResponse>;

				return result.data.batchGetFormGroups;
			} else {
				const photoLogs = await bulkGetPhotoLogs(ids);
				return photoLogs;
			}
		} catch (error) {
			recordSentry({ error, msg: "Error retrieving photologs:" });
		}
	}
	return [];
}

export default batchRetrievePhotoLogs;
